import {Fragment, useEffect, useRef, useState} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import {connect} from 'react-redux';
import {classNames} from '@commonFunction';
import IconReportEmail from './icons/reportemail';
import IconReportNumber from './icons/reportcontact';
import LocaleStrings from '../../../../languages';
import toast from 'react-hot-toast';

export const REPORT_TYPE_EMAIL = 'REPORT_TYPE_EMAIL';
export const REPORT_TYPE_NUMBER = 'REPORT_TYPE_NUMBER';

function ReportContactPopup(props) {
  let {contacttype, contact} = props;

  if (!contacttype) {
    contacttype = 'email';
  }

  const [open, setOpen] = useState(false);

  const [selected, setSelected] = useState(
    contacttype === 'phone' ? 'outofservice' : 'invalid',
  );

  const cancelButtonRef = useRef(null);

  const [correctEmail, setCorrectEmail] = useState('');
  const [others, setOthers] = useState('');
  const [correctPhone, setCorrectPhone] = useState('');

  const type = contacttype === 'phone' ? REPORT_TYPE_NUMBER : REPORT_TYPE_EMAIL;

  const clearAll = () => {
    setCorrectEmail('');
    setOthers('');
    setCorrectPhone('');
  };

  useEffect(() => {
    if (open !== props.open) {
      setOpen(props.open);
      setSelected(contacttype === 'phone' ? 'outofservice' : 'invalid');
      clearAll();
    }
  }, [props.open]);

  const isValid = () => {
    let validated = true;
    if (selected === 'others' && others === '') {
      toast.error(LocaleStrings.flag.email.othersPlaceholder);
      validated = false;
    } else if (
      selected === 'invalid' &&
      type === REPORT_TYPE_EMAIL &&
      correctEmail === ''
    ) {
      toast.error(LocaleStrings.flag.email.invalidPlaceholder);
      validated = false;
    } else if (
      selected === 'invalid' &&
      correctPhone === '' &&
      type === REPORT_TYPE_NUMBER
    ) {
      toast.error(LocaleStrings.flag.phone.invalidPlaceholder);
      validated = false;
    }

    return validated;
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="items-start justify-start">
                    {type === REPORT_TYPE_NUMBER ? (
                      <IconReportEmail />
                    ) : (
                      <IconReportNumber />
                    )}
                  </div>
                  <div className="mt-3 text-left sm:mt-5">
                    <Dialog.Title
                      as="h2"
                      className="text-lg font-semibold leading-6 text-gray-900">
                      {type === REPORT_TYPE_EMAIL
                        ? LocaleStrings.flag.email.title
                        : LocaleStrings.flag.phone.title}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {type === REPORT_TYPE_EMAIL
                          ? LocaleStrings.flag.email.subtitle
                          : LocaleStrings.flag.phone.subtitle}
                      </p>
                      <p className="text-sm text-gray-500">
                        {type === REPORT_TYPE_EMAIL
                          ? LocaleStrings.flag.email.subtitle2
                          : LocaleStrings.flag.phone.subtitle2}
                      </p>
                    </div>
                  </div>
                  <div className="py-4">
                    {type === REPORT_TYPE_EMAIL ? (
                      <fieldset className="mt-2">
                        <div className="space-y-2">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                id="invalid"
                                aria-describedby={`new-description`}
                                name="options"
                                type="radio"
                                value={'invalid'}
                                defaultChecked={selected === 'invalid'}
                                className="h-4 w-4 border-gray-300 text-primary focus:ring-0"
                                onChange={e => {
                                  setSelected(e.target.value);
                                }}
                              />
                            </div>
                            <div className="ml-3 text-base leading-6">
                              <label
                                htmlFor="invalid"
                                className="text-gray-900">
                                {LocaleStrings.flag.email.invalid}
                              </label>
                            </div>
                          </div>
                          <div
                            className={classNames(
                              selected === 'invalid'
                                ? 'opacity-100'
                                : 'opacity-50',
                            )}>
                            <input
                              autoComplete="off"
                              disabled={selected !== 'invalid'}
                              name="email"
                              className="cust-input-field w-full text-xl"
                              placeholder={
                                LocaleStrings.flag.email.invalidPlaceholder
                              }
                              value={correctEmail}
                              onChange={e => setCorrectEmail(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className={classNames('py-4')}>
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                id="others"
                                name="options"
                                type="radio"
                                value={'others'}
                                defaultChecked={selected === 'others'}
                                className="h-4 w-4 border-gray-300 text-primary focus:ring-0"
                                onChange={e => {
                                  setSelected(e.target.value);
                                }}
                              />
                            </div>
                            <div className="ml-3 text-base leading-6">
                              <label htmlFor="new" className="text-gray-900">
                                {LocaleStrings.flag.email.others}
                              </label>
                            </div>
                          </div>
                          <div
                            className={classNames(
                              selected === 'others'
                                ? 'opacity-100'
                                : 'opacity-50',
                            )}>
                            <input
                              autoComplete="off"
                              disabled={selected !== 'others'}
                              name="others"
                              className="cust-input-field w-full text-xl"
                              placeholder={
                                LocaleStrings.flag.email.othersPlaceholder
                              }
                              value={others}
                              onChange={e => setOthers(e.target.value)}
                            />
                          </div>
                        </div>
                      </fieldset>
                    ) : (
                      <fieldset>
                        <div className="space-y-2">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                id="outofservice"
                                aria-describedby={`new-description`}
                                name="options"
                                type="radio"
                                value={'outofservice'}
                                defaultChecked={selected === 'outofservice'}
                                className="h-4 w-4 border-gray-300 text-primary focus:ring-0"
                                onChange={e => {
                                  setSelected(e.target.value);
                                }}
                              />
                            </div>
                            <div className="ml-3 text-base leading-6">
                              <label
                                htmlFor="outofservice"
                                className="text-gray-900">
                                {LocaleStrings.flag.phone.outofservice}
                              </label>
                            </div>
                          </div>
                          <div className="relative flex items-start pt-2">
                            <div className="flex h-6 items-center">
                              <input
                                id="invalid"
                                aria-describedby={`new-description`}
                                name="options"
                                type="radio"
                                value={'invalid'}
                                defaultChecked={selected === 'invalid'}
                                className="h-4 w-4 border-gray-300 text-primary focus:ring-0"
                                onChange={e => {
                                  setSelected(e.target.value);
                                }}
                              />
                            </div>
                            <div className="ml-3 text-base leading-6">
                              <label
                                htmlFor="invalid"
                                className="text-gray-900 text-base">
                                {LocaleStrings.flag.phone.invalid}
                              </label>
                            </div>
                          </div>
                          <div
                            className={classNames(
                              selected === 'invalid'
                                ? 'opacity-100'
                                : 'opacity-50',
                            )}>
                            <input
                              autoComplete="off"
                              disabled={selected !== 'invalid'}
                              name="phone"
                              className="cust-input-field w-full text-xl"
                              placeholder={
                                LocaleStrings.flag.phone.invalidPlaceholder
                              }
                              value={correctPhone}
                              onChange={e => setCorrectPhone(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className={classNames('py-3')}>
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                id="others"
                                name="options"
                                type="radio"
                                value={'others'}
                                defaultChecked={selected === 'others'}
                                className="h-4 w-4 border-gray-300 text-primary focus:ring-0"
                                onChange={e => {
                                  setSelected(e.target.value);
                                }}
                              />
                            </div>
                            <div className="ml-3 text-base leading-6">
                              <label htmlFor="new" className="text-gray-900">
                                {LocaleStrings.flag.email.others}
                              </label>
                            </div>
                          </div>
                          <div
                            className={classNames(
                              selected === 'others'
                                ? 'opacity-100'
                                : 'opacity-50',
                            )}>
                            <input
                              autoComplete="off"
                              disabled={selected !== 'others'}
                              name="others"
                              className="cust-input-field w-full text-xl"
                              placeholder={
                                LocaleStrings.flag.email.othersPlaceholder
                              }
                              value={others}
                              onChange={e => setOthers(e.target.value)}
                            />
                          </div>
                        </div>
                      </fieldset>
                    )}
                  </div>
                </div>
                <div className="mt-6 grid grid-flow-row-dense grid-cols-2 gap-3">
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    onClick={() => props.onClose()}
                    ref={cancelButtonRef}>
                    {LocaleStrings.flag.cancel}
                  </button>
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:opacity-80"
                    onClick={() => {
                      if (isValid()) {
                        let data = {};
                        data.downvotereason = selected;
                        data.reasonnote =
                          selected === 'others'
                            ? others
                            : type === REPORT_TYPE_EMAIL
                              ? correctEmail
                              : correctPhone;

                        props.onSubmit(data);
                      }
                    }}>
                    {LocaleStrings.flag.email.submit}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

function mapStateToProps(state, ownProps) {
  var {session, user} = state;
  return {
    session,
    user,
  };
}

export default connect(mapStateToProps, null)(ReportContactPopup);
